function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_538",
  "data-name": "Grupo 538"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_857",
  "data-name": "Caminho 857",
  d: "M361.276,68.754a12,12,0,1,1,12-12A12.013,12.013,0,0,1,361.276,68.754Zm0-22.533a10.534,10.534,0,1,0,10.533,10.533A10.546,10.546,0,0,0,361.276,46.221Z",
  transform: "translate(-349.276 -44.754)"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_540",
  "data-name": "Grupo 540",
  transform: "translate(11 6)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_539",
  "data-name": "Grupo 539"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_858",
  "data-name": "Caminho 858",
  d: "M356.658,49.435a.877.877,0,0,1,.217-.6.82.82,0,0,1,.644-.245.834.834,0,0,1,.648.245.867.867,0,0,1,.221.6.905.905,0,0,1-1.513.592A.846.846,0,0,1,356.658,49.435Zm1.58,10.813h-1.461V51.7h1.461Z",
  transform: "translate(-356.658 -48.59)"
})));

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "info-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.fe0461f7.svg";
export { ForwardRef as ReactComponent };